/**
 * @type {Object}
 * @property {array}  data  Item data
 */
const initialState = {
    deliveryTypes: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerDeliveryType = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_DELIVERY_TYPES':
            var { data } = action;
            newState.deliveryTypes = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerDeliveryType;